<h1 mat-dialog-title>Fechamento de venda</h1>
<div mat-dialog-content class="full-width">
    <mat-form-field appearance="fill">
        <mat-label>Valor Total a Pagar</mat-label>
        <input matInput currencyMask [(ngModel)]="data.areceberCliente.valor"
            [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }" />
    </mat-form-field>
    <br>
    <mat-form-field appearance="fill">
        <mat-label>Valor Pago</mat-label>
        <input matInput currencyMask [(ngModel)]="data.pago" [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }"
            (ngModelChange)="calc()" required>
    </mat-form-field>
    <br>
    <mat-form-field appearance="fill">
        <mat-label>Forma de pagamento</mat-label>
        <mat-select id="pagamento" name="pagamento" [(value)]="data.payment" required>
            <mat-option [value]="payment" *ngFor="let payment of payments">{{payment.name}}
            </mat-option>
        </mat-select>
    </mat-form-field>
    <br>
    <mat-form-field appearance="fill">
        <mat-label>Troco</mat-label>
        <input matInput currencyMask readonly [(ngModel)]="data.troco"
            [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }">
    </mat-form-field>
</div>
<div mat-dialog-actions>
    <button mat-button (click)="onCancel()">Cancelar</button>
    <button [disabled]="data.payment==null" mat-button [mat-dialog-close]="data"
        cdkFocusInitial>Confirmar Venda</button>
</div>